import React, { useState } from 'react';
import { TextField, Autocomplete, Box, Typography } from '@mui/material';
import { Title } from '../types';
import { searchTitles } from '../services/api';

interface SearchBarProps {
    onTitleSelect: (title: Title) => void;
}

export const SearchBar: React.FC<SearchBarProps> = ({ onTitleSelect }) => {
    const [options, setOptions] = useState<Title[]>([]);
    const [loading, setLoading] = useState(false);

    const handleSearch = async (query: string) => {
        if (query.length < 2) return;
        setLoading(true);
        try {
            const results = await searchTitles(query);
            setOptions(results);
        } catch (error) {
            console.error('Search error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Autocomplete
            options={options}
            getOptionLabel={(option) => `${option.title_name} (${option.release_year})`}
            loading={loading}
            onChange={(_, value) => value && onTitleSelect(value)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Search for a show or movie"
                    variant="outlined"
                    onChange={(e) => handleSearch(e.target.value)}
                    fullWidth
                />
            )}
            renderOption={(props, option) => (
                <Box component="li" {...props}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {option.poster_url && (
                            <img
                                src={option.poster_url}
                                alt={option.title_name}
                                style={{ width: 50, marginRight: 10 }}
                            />
                        )}
                        <Box>
                            <Typography variant="body1">{option.title_name}</Typography>
                            <Typography variant="body2" color="text.secondary">
                                {option.release_year}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            )}
        />
    );
};